/* eslint-disable react-hooks/rules-of-hooks */
import {
  DeleteOutlined,
  ExportOutlined,
  FormOutlined,
  PlusOutlined,
  PrinterOutlined,
  ReloadOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  Table,
  Tooltip,
  notification,
} from "antd";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import excel from "xlsx";
import "./style.css";

import { Env, PrintFonts } from "./../../../styles";

const { TextArea } = Input;
const { Option } = Select;

export default function TasksAccounts(props) {
  const [api, contextHolder] = notification.useNotification();
  const [filteredInfo, setFilteredInfo] = useState({});

  const [sortedInfo, setSortedInfo] = useState({});
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(true);
  const [loadReport, setLoadReport] = useState(false);
  const [tstypes, setTstypes] = useState([]);
  const [types, setTypes] = useState([]);
  const [namesFilter, setNamesFilter] = useState([]);
  const [currentYear, setCurrentYear] = useState(dayjs().format("YYYY"));

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDModalVisible, setIsDModalVisible] = useState(false);
  const [isTransferModalVisible, setIsTransferModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [editingUserId, setEditingUserId] = useState(null);
  const [editingUserName, setEditingUserName] = useState(null);

  const [saving, setSaving] = useState(false);
  const [dsaving, setDSaving] = useState(false);
  const [transferring, setTransferring] = useState(false);
  const [resetting, setResetting] = useState(false);

  const [tasksTypes, setTasksTypes] = useState([]);
  const [empNames, setEmpNames] = useState([]);
  const [selectedName, setSelectedName] = useState(null);
  const [start, setStart] = useState(
    new Date(new Date().setDate(new Date().getDate() - 30))
      .toISOString()
      .slice(0, 10)
  );
  const [end, setEnd] = useState(new Date().toISOString().slice(0, 10));
  const [loadUsers, setLoadUsers] = useState(false);
  const [update, setUpdate] = useState(false);
  const [categories, setCategories] = useState([]);
  const [pdata, setPData] = useState([]);
  const [categoriesFilter, setCategoriesFilter] = useState([]);
  const [annTasks, setAnnTasks] = useState([]);
  const [pannTasks, setPAnnTasks] = useState([]);

  const normalizeText = (value) =>
    (value ?? "").toString().trim().toLowerCase();
  const matchesFilterValue = (recordValue, filterValue) =>
    normalizeText(recordValue) === normalizeText(filterValue);
  const isAnnualTaskLabel = (label) => {
    const text = normalizeText(label);
    return (
      text.includes("سنوية") ||
      text.includes("سنوي") ||
      text.includes("سنة") ||
      text.includes("yearly") ||
      text.includes("annual")
    );
  };

  const handleTransferLeaves = async () => {
    try {
      const values = await transferForm.validateFields();
      setTransferring(true);

      // التحقق من صحة القيم قبل الإرسال
      if (!values.from_year || !values.to_year) {
        api.error({
          message: "خطأ في البيانات",
          description: "يرجى التأكد من اختيار السنة المصدر والسنة الهدف",
          placement: "bottomLeft",
          duration: 10,
        });
        setTransferring(false);
        return;
      }

      // تحضير بيانات الرصيد الافتتاحي (بالدقائق)
      const openingBalances = {};
      if (
        values.opening_balances &&
        typeof values.opening_balances === "object"
      ) {
        Object.keys(values.opening_balances).forEach((vacationTypeId) => {
          const amount = parseFloat(values.opening_balances[vacationTypeId]);
          if (!isNaN(amount) && amount > 0) {
            openingBalances[vacationTypeId] = amount; // بالدقائق
          }
        });
      }

      const requestData = {
        from_year: values.from_year.format("YYYY"),
        to_year: values.to_year.format("YYYY"),
        vacation_types:
          values.vacation_types && values.vacation_types.length > 0
            ? values.vacation_types
            : null,
        users: values.users && values.users.length > 0 ? values.users : null,
        opening_balances:
          Object.keys(openingBalances).length > 0 ? openingBalances : null,
      };

      const response = await axios.post(
        Env.HOST_SERVER_NAME + "transfer-leaves-to-new-year",
        requestData
      );

      if (response.data.success) {
        api.success({
          message: "نجح الترحيل",
          description: `تم ترحيل ${response.data.transferred_count} سجل بنجاح`,
          placement: "bottomLeft",
          duration: 10,
        });
        setIsTransferModalVisible(false);
        transferForm.resetFields();
        setUpdate(update + 1);
      } else {
        api.error({
          message: "فشل الترحيل",
          description: response.data.message || "حدث خطأ أثناء الترحيل",
          placement: "bottomLeft",
          duration: 10,
        });
      }
    } catch (error) {
      console.error("Transfer error:", error);
      let errorMessage = "حدث خطأ أثناء الترحيل. يرجى المحاولة مرة أخرى.";
      if (error.response) {
        if (error.response.status === 500) {
          errorMessage = error.response.data?.message || "خطأ في الخادم (500).";
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        }
      }
      api.error({
        message: "فشل الترحيل",
        description: errorMessage,
        placement: "bottomLeft",
        duration: 10,
      });
    } finally {
      setTransferring(false);
    }
  };

  const onDFinish = () => {
    dform.validateFields().then((values) => {
      setDSaving(true);
      const isAllUsers = values.user_id === "__ALL_USERS__";

      const payload = {
        ...values,
        user_id: isAllUsers ? null : values.user_id,
        all_users: isAllUsers,
        discount_date: values.discount_date ? values.discount_date.format('YYYY-MM-DD') : null,
        year: values.year ? values.year.format('YYYY') : null,
      };

      axios
        .post(
          Env.HOST_SERVER_NAME + "discount-task-account",
          payload
        )
        .then((response) => {
          setDSaving(false);
          setIsDModalVisible(false);
          dform.resetFields();
          setUpdate(update + 1);
          api.success({
            message: response.data?.message || "تم خصم الرصيد بنجاح",
            placement: "bottomLeft",
            duration: 10,
          });
        })
        .catch(function (error) {
          const msg =
            error.response?.data?.message ||
            (error.response?.data?.errors &&
              Object.values(error.response.data.errors).flat().join(" ")) ||
            "يوجد مشكلة في الاتصال بالسرفر";
          api.error({
            message: "فشل الخصم",
            description: msg,
            placement: "bottomLeft",
            duration: 10,
          });
          setDSaving(false);
        });
    });
  };


















  const showAccount = (user_id) => {
    setIsEditMode(true);
    setEditingUserId(user_id);

    // البحث عن اسم الموظف
    const user = empNames.find((emp) => emp.value === user_id);
    const userName = user ? user.label : "موظف";
    setEditingUserName(userName);

    setIsModalVisible(true);

    axios
      .get(
        Env.HOST_SERVER_NAME +
        "get-tasks-statment/" +
        user_id +
        "/" +
        currentYear
      )
      .then((response) => {
        const tasks = response.data || [];

        // دمج السجلات التي لها نفس task_id (نوع الإجازة) في سجل واحد
        const mergedTasks = {};

        tasks.forEach((task) => {
          const taskId = task.vacationstype_id || task.task_id;
          const key = `${taskId}_${task.type || ""}`;

          if (!mergedTasks[key]) {
            // إنشاء سجل جديد
            mergedTasks[key] = {
              id: task.id, // نستخدم أول id
              user_id: task.user_id,
              task_id: taskId,
              type: task.type,
              amount: parseFloat(task.amount || 0),
              period_type: task.period_type || "yearly",
              note: task.note || "",
              ids: [task.id], // حفظ جميع الـ IDs للمرجع
            };
          } else {
            // دمج السجلات: جمع المبالغ ودمج الملاحظات
            mergedTasks[key].amount += parseFloat(task.amount || 0);
            mergedTasks[key].ids.push(task.id);
            // دمج الملاحظات
            if (task.note && task.note.trim()) {
              if (mergedTasks[key].note && mergedTasks[key].note.trim()) {
                mergedTasks[key].note += " | " + task.note;
              } else {
                mergedTasks[key].note = task.note;
              }
            }
          }
        });

        // إنشاء سجلات لجميع أنواع الإجازات المتاحة
        // إذا كان النوع موجوداً في mergedTasks، نستخدم بياناته
        // وإلا ننشئ سجل فارغ
        const allTasks = tasksTypes.map((vacationType) => {
          // البحث عن سجل موجود لهذا النوع
          const existingTask = Object.values(mergedTasks).find(
            (task) => task.task_id === vacationType.value
          );

          if (existingTask) {
            // إذا كان موجوداً، نستخدم بياناته
            return {
              id: existingTask.id,
              user_id: existingTask.user_id,
              task_id: existingTask.task_id,
              type: existingTask.type,
              amount: existingTask.amount,
              period_type: existingTask.period_type || "monthly",
              note: existingTask.note || "",
              ids: existingTask.ids || [existingTask.id],
              ids_string: JSON.stringify(existingTask.ids || [existingTask.id]),
            };
          } else {
            // إذا لم يكن موجوداً، ننشئ سجل فارغ
            return {
              id: null,
              user_id: user_id,
              task_id: vacationType.value,
              type: null,
              amount: 0,
              period_type: "yearly",
              note: "",
              ids: [],
              ids_string: JSON.stringify([]),
            };
          }
        });

        // تعبئة النموذج بالبيانات
        form.setFieldsValue({ tasks: allTasks });

        // تعبئة النموذج العلوي بالبيانات من أول سجل موجود
        const firstExistingTask = allTasks.find((task) => task.id !== null);
        if (firstExistingTask) {
          gform.setFieldsValue({
            task_id: firstExistingTask.task_id,
            type: firstExistingTask.type,
            period_type: firstExistingTask.period_type || "monthly",
            amount: firstExistingTask.amount,
            note: firstExistingTask.note || "",
          });
        } else {
          // إذا لم تكن هناك سجلات موجودة، نستخدم القيم الافتراضية
          gform.resetFields();
        }
      })
      .catch(function (error) {
        console.log(error);
        notification.error({
          message: "خطأ في جلب البيانات",
          description: "حدث خطأ أثناء جلب بيانات الموظف",
          placement: "bottomLeft",
          duration: 10,
        });
      });
  };
  const getColumnsVac = () => {
    if (tasksTypes.length > 0) {
      const ncolumns = [
        {
          title: "اسم الموظف",
          dataIndex: "empName",
          key: "empName",
          sorter: (a, b) => a.empName.length - b.empName.length,
          sortOrder: sortedInfo.columnKey === "empName" && sortedInfo.order,
          ellipsis: false,
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <NamesFilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            />
          ),
          onFilter: (value, record) =>
            matchesFilterValue(record.empName, value),
          filteredValue: filteredInfo.empName || null,
        },
        {
          title: "الإدارة",
          dataIndex: "category",
          key: "category",
          sorter: (a, b) => a.category.length - b.category.length,
          sortOrder: sortedInfo.columnKey === "category" && sortedInfo.order,
          ellipsis: false,
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <CategoriesFilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            />
          ),
          onFilter: (value, record) => {
            const result = matchesFilterValue(record.category, value);
            return result;
          },
          filteredValue: filteredInfo.category || null,
        },
        {
          title: "الوظيفة",
          dataIndex: "job",
          key: "job",
          ellipsis: true,
        },
      ];
      var col = "[";
      tasksTypes.map((task) => {
        col +=
          '{"title":"' +
          task.label +
          '","dataIndex":"' +
          task.label +
          '","key":"' +
          task.label +
          '"},';
      });
      var nc = JSON.parse(col.substring(0, col.length - 1) + "]");
      nc.map((col) => {
        ncolumns.push(col);
      });
      ncolumns.push({
        title: "إجراءات",
        dataIndex: "user_id",
        key: "user_id",
        ellipsis: true,
        render: (user_id) => (
          <>
            <Tooltip title="تعديل / عرض رصيد الموظف">
              <Button
                onClick={function () {
                  showAccount(user_id);
                }}
                type="primary"
                shape="round"
                icon={<FormOutlined />}
              />
            </Tooltip>
            <Tooltip
              title={`تصفير أرصدة هذا الموظف لسنة ${currentYear} فقط (حسب السنة أعلى الجدول)`}
            >
              <Button
                style={{ marginRight: "8px" }}
                danger
                shape="round"
                icon={<ReloadOutlined />}
                loading={saving}
                onClick={function () {
                  deleteUserYearVacations(user_id);
                }}
                aria-label={`تصفير أرصدة الموظف لسنة ${currentYear}`}
              />
            </Tooltip>
          </>
        ),
      });
      return ncolumns;
    } else return [];
  };

  useEffect(() => {
    setLoad(true);

    const empPromise = axios.get(Env.HOST_SERVER_NAME + "get-emp-names");
    const tasksPromise = axios.get(Env.HOST_SERVER_NAME + "get-tasks-types-re");
    const restTasksPromise = (end != "")
      ? axios.get(Env.HOST_SERVER_NAME + "get-rest-tasks/" + currentYear)
      : Promise.resolve({ data: { tasks: [] } });

    Promise.all([empPromise, tasksPromise, restTasksPromise])
      .then(([empResponse, tasksResponse, restResponse]) => {
        setEmpNames(empResponse.data);
        setTstypes(empResponse.data);
        const emp = empResponse.data;

        setTasksTypes(tasksResponse.data);
        const tasks = tasksResponse.data;

        let records = [];

        if (
          restResponse.data.tasks?.length > 0 &&
          emp?.length > 0 &&
          tasks?.length > 0
        ) {
          var vacData = "[";
          emp.map((user, index) => {
            // Check if user has tasks in response
            const userTasks = restResponse.data.tasks.filter(t => t.user_id == user.value);
            // If we want to show all employees even if zero balance, keep logic.
            // The original code assumes we iterate emp and find match in tasks.

            const categoryTask = userTasks[0]; // For category/job info
            if (!categoryTask && restResponse.data.tasks.length > 0) {
              // Try to find category/job from other sources or skip? 
              // Original code: record.user_id == user.value. 
              // If undefined, it prints "undefinied".
            }

            vacData +=
              "{" +
              '"empName":"' +
              user.label +
              '","user_id":"' +
              user.value +
              '","category":"' +
              (userTasks[0]?.category || "") +
              '","job":"' +
              (userTasks[0]?.job || "") +
              '",';

            var vacDetails = "";
            tasks.map((task) => {
              var dur = restResponse.data.tasks?.filter(
                (record) =>
                  record.uid == user.value && record.vid == task.value
              );

              if (dur.length > 0) {
                const minutes = Math.abs(dur[0].rest);
                const hours = Math.floor(minutes / 60);
                const mins = minutes % 60;

                // عرض الساعات بدون padding إذا كانت أكثر من 99 ساعة
                const hoursStr =
                  hours >= 100
                    ? String(hours)
                    : String(hours).padStart(2, "0");
                if (dur[0].rest < 0) {
                  dur = "-" + hoursStr + ":" + String(mins).padStart(2, "0");
                } else {
                  dur = hoursStr + ":" + String(mins).padStart(2, "0");
                }
              } else {
                dur = "00:00";
              }

              vacDetails += '"' + task.label + '":"' + dur + '",';
            });

            vacData += vacDetails.substring(0, vacDetails.length - 1);
            vacData += "},";
          });

          // Verify vacData is valid JSON before parsing
          if (vacData.length > 1) {
            var json = JSON.parse(
              vacData.substring(0, vacData.length - 1) + "]"
            );
            records = json;
            setData(json);
            setPData(json);
          } else {
            setData([]);
            setPData([]);
          }
        } else {
          setData([]);
          setPData([]);
        }

        let names = [];
        let categories = [];
        records.forEach((element) => {
          if (!names.some((item) => element.empName == item.text)) // Fix name check to match data
            names.push({
              text: element["empName"],
              value: element["empName"],
            });
          if (!categories.some((item) => element.category == item.text))
            categories.push({
              text: element["category"],
              value: element["category"],
            });
        });
        names = names.sort((a, b) => a.text.localeCompare(b.text));

        const namesWithSelectAll = [
          { text: "تحديد الكل", value: "SELECT_ALL_NAMES" },
          ...names,
        ];

        categories = categories.sort((a, b) => a.text.localeCompare(b.text));

        const categoriesWithSelectAll = [
          { text: "تحديد الكل", value: "SELECT_ALL_CATEGORIES" },
          ...categories,
        ];

        setNamesFilter(namesWithSelectAll);
        setCategoriesFilter(categoriesWithSelectAll);

        // setCategories(response.data.categories); // This line in original code used response from EMP NAMES?? 
        // No, line 437: setCategories(response.data.categories). 
        // Wait, line 437 in original code used `response` which was `get-rest-tasks` response?
        // Let's check original line 337. `get-rest-tasks` response.

        if (restResponse && restResponse.data && restResponse.data.categories) {
          setCategories(restResponse.data.categories);
        }

        if (restResponse && restResponse.data && restResponse.data.types) {
          setTypes(restResponse.data.types);
        }

        setLoad(false);
      })
      .catch(function (error) {
        console.log("Error loading data:", error);
        setLoad(false);
      });
    axios
      .get(Env.HOST_SERVER_NAME + "get-annualy-tasks-report/2/" + currentYear)
      .then((response) => {
        setAnnTasks(response.data);
        setPAnnTasks(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [start, end, update, currentYear]);

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);

    if (!filters || Object.keys(filters).length === 0) {
      setPData(data);
      setPAnnTasks(annTasks);
      return;
    }

    const hasActiveFilters = Object.values(filters).some(
      (value) => Array.isArray(value) && value.length > 0
    );

    if (!hasActiveFilters) {
      setPData(data);
      setPAnnTasks(annTasks);
      return;
    }

    const filterPredicate = (item) =>
      Object.entries(filters).every(([key, selectedValues]) => {
        if (!Array.isArray(selectedValues) || !selectedValues.length) {
          return true;
        }

        return selectedValues.some((filterValue) =>
          matchesFilterValue(item[key], filterValue)
        );
      });

    setPData(data.filter(filterPredicate));
    setPAnnTasks(annTasks.filter(filterPredicate));
  };
  const printReport = () => {
    var report = document.getElementById("att-report");
    // var report = document.getElementById("ann-report");
    //var report=document.body;
    var mywindow = window.open("");
    mywindow.document.write(
      "<html><head><title></title> <style>" +
      PrintFonts.getPrintFontsCSS() +
      "body{font - size:12px;margin:0} " +
      "</style>"
    );
    mywindow.document.write('</head><body dir="rtl" style="font-size:12px;" >');
    mywindow.document.write(report.innerHTML);
    mywindow.document.write("</body></html>");

    // mywindow.document.close();
    mywindow.onload = function () {
      // wait until all resources loaded
      mywindow.focus(); // necessary for IE >= 10
      mywindow.print(); // change window to mywindow
      mywindow.close(); // change window to mywindow
    };
  };

  const exportToExcel = (type, fn, dl) => {
    var elt = document.getElementById("att-report");
    if (elt) {
      var wb = excel.utils.table_to_book(elt, {
        sheet: "sheet1",
        cellStyles: true,
      });
      return dl
        ? excel.write(wb, {
          bookType: type,
          bookSST: true,
          type: "base64",
          cellStyles: true,
        })
        : excel.writeFile(wb, fn || "كشف أرصدة الإجازات." + (type || "xlsx"), {
          bookSST: true,
          type: "base64",
          cellStyles: true,
        });
    }
  };
  const openNotification = (placement) => {
    notification.success({
      message: <span> تم إضافة الرصيد بنجاح </span>,
      placement,
      duration: 10,
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsEditMode(false);
    setEditingUserId(null);
    setEditingUserName(null);
    form.resetFields();
    gform.resetFields();
  };

  const handleDCancel = () => {
    setIsDModalVisible(false);
    dform.resetFields();
  };
  const showUsersDebt = async () => {
    try {
      await gform.validateFields(["task_id", "period_type", "balance_year"]);
    } catch (error) {
      return;
    }

    setLoadUsers(true);
    axios
      .get(Env.HOST_SERVER_NAME + "get-users-long-debts/")
      .then((response) => {
        setLoadUsers(false);

        var tasks = response.data;
        const finalData = tasks.map((item) => ({
          ...item,
          amount: gform.getFieldValue("amount"),
          task_id: gform.getFieldValue("task_id"),
          type: gform.getFieldValue("type"),
          period_type: gform.getFieldValue("period_type") || "yearly",
          balance_year: gform.getFieldValue("balance_year")
            ? gform.getFieldValue("balance_year").format("YYYY")
            : currentYear,
        }));

        form.setFieldsValue({ tasks: finalData });
      })
      .catch(function (error) {
        console.log(error);
        setLoadUsers(false);
      });
  };
  const [form] = Form.useForm();
  const [dform] = Form.useForm();
  const [gform] = Form.useForm();
  const [transferForm] = Form.useForm();

  const deleteUserYearVacations = (user_id) => {
    const user = empNames.find((emp) => emp.value === user_id);
    const userName = user ? user.label : "الموظف";

    Modal.confirm({
      title: "تأكيد تصفير أرصدة الموظف",
      content: `هل أنت متأكد من تصفير (حذف سجلات أرصدة) ${userName} لسنة ${currentYear} فقط؟ لا يمكن التراجع.`,
      okText: "تصفير",
      cancelText: "إلغاء",
      okType: "danger",
      onOk: async () => {
        setSaving(true);
        try {
          const res = await axios.delete(
            Env.HOST_SERVER_NAME +
            `delete-user-year-vacations/${user_id}/${currentYear}`
          );

          if (res.data?.success) {
            notification.success({
              message: "تم الحذف بنجاح",
              description: res.data.message,
              placement: "bottomLeft",
              duration: 10,
            });
            setUpdate(update + 1);
          } else {
            notification.error({
              message: "فشل الحذف",
              description: res.data?.message || "حدث خطأ أثناء الحذف",
              placement: "bottomLeft",
              duration: 10,
            });
          }
        } catch (error) {
          notification.error({
            message: "فشل الحذف",
            description:
              error.response?.data?.message ||
              "حدث خطأ أثناء الحذف. يرجى المحاولة مرة أخرى.",
            placement: "bottomLeft",
            duration: 10,
          });
        } finally {
          setSaving(false);
        }
      },
    });
  };

  const onFinish = () => {
    setSaving(true);
    const formData = form.getFieldsValue();

    // إضافة الحقول الجديدة من النموذج العلوي
    const globalData = gform.getFieldsValue();

    // تحديث البيانات مع الحقول الجديدة
    if (formData.tasks) {
      formData.tasks = formData.tasks
        .map((task) => {
          // تحويل ids_string إلى array إذا كان موجوداً
          let ids = [];
          if (task.ids_string) {
            try {
              ids = JSON.parse(task.ids_string);
            } catch (e) {
              ids = task.id ? [task.id] : [];
            }
          } else if (task.ids) {
            ids = task.ids;
          } else if (task.id) {
            ids = [task.id];
          }

          return {
            ...task,
            period_type: task.period_type || globalData.period_type || "yearly",
            balance_year: task.balance_year
              ? String(task.balance_year).slice(0, 4)
              : globalData.balance_year
                ? globalData.balance_year.format("YYYY")
                : currentYear,
            ids: ids, // إرسال ids array للـ Backend لحذف السجلات المكررة
          };
        })
        // تصفية السجلات: في وضع التعديل، نرسل جميع السجلات (حتى الفارغة) للـ Backend
        // الـ Backend سيتعامل مع حذف السجلات الفارغة تلقائياً
        .filter((task) => {
          // في وضع الإضافة، نحذف السجلات الفارغة
          if (!isEditMode) {
            return (
              task.amount && task.amount > 0 && task.user_id && task.task_id
            );
          }
          // في وضع التعديل، نرسل جميع السجلات (الـ Backend سيتعامل معها)
          return task.user_id && task.task_id;
        });
    }

    axios
      .post(Env.HOST_SERVER_NAME + "add-balance-tasks", formData)
      .then((response) => {
        setSaving(false);
        setIsModalVisible(false);
        setIsEditMode(false);
        setEditingUserId(null);
        setEditingUserName(null);
        form.resetFields();
        gform.resetFields();
        setUpdate(update + 1);
        notification.success({
          message: isEditMode
            ? "تم تعديل الرصيد بنجاح"
            : "تم إضافة الرصيد بنجاح",
          description: isEditMode
            ? `تم تعديل رصيد ${editingUserName || "الموظف"} لسنة ${currentYear}`
            : `تم إضافة الرصيد بنجاح لسنة ${globalData.balance_year
              ? globalData.balance_year.format("YYYY")
              : currentYear
            }`,
          placement: "bottomLeft",
          duration: 10,
        });
      })
      .catch(function (error) {
        alert("يوجد مشكلة في الاتصال بالسرفر!");
        setSaving(false);
      });
  };


  function printAnnualyReport() {
    setLoadReport(true);
    var report = document.getElementById("ann-report");
    var mywindow = window.open("");
    setLoadReport(false);
    mywindow.document.write(
      "<html><head><title></title> <style>" +
      PrintFonts.getPrintFontsCSS() +
      "body{font - size:12px;margin:0} " +
      "</style>"
    );
    mywindow.document.write('</head><body dir="rtl" style="font-size:12px;" >');
    mywindow.document.write(report.innerHTML);
    mywindow.document.write("</body></html>");
    mywindow.document.close();
    mywindow.onload = function () {
      // wait until all resources loaded
      mywindow.focus(); // necessary for IE >= 10
      mywindow.print(); // change window to mywindow
      mywindow.close(); // change window to mywindow
    };
  }
  const onChange = (all, date) => {
    setCurrentYear(date);
  };

  const handleResetYear = () => {
    Modal.confirm({
      title: "تأكيد تصفير السنة",
      content: `هل أنت متأكد من تصفير جميع الإجازات لسنة ${currentYear}؟ هذا الإجراء لا يمكن التراجع عنه.`,
      okText: "نعم، صفّر",
      cancelText: "إلغاء",
      okType: "danger",
      onOk: async () => {
        setResetting(true);
        try {
          const response = await axios.post(
            Env.HOST_SERVER_NAME + "reset-year-vacations",
            {
              year: currentYear,
            }
          );

          if (response.data.success) {
            api.success({
              message: "تم التصفير بنجاح",
              description: `تم تصفير جميع الإجازات لسنة ${currentYear} بنجاح`,
              placement: "bottomLeft",
              duration: 10,
            });
            setUpdate(update + 1);
          } else {
            api.error({
              message: "فشل التصفير",
              description: response.data.message || "حدث خطأ أثناء التصفير",
              placement: "bottomLeft",
              duration: 10,
            });
          }
        } catch (error) {
          console.error("Reset year error:", error);
          api.error({
            message: "فشل التصفير",
            description:
              error.response?.data?.message ||
              "حدث خطأ أثناء التصفير. يرجى المحاولة مرة أخرى.",
            placement: "bottomLeft",
            duration: 10,
          });
        } finally {
          setResetting(false);
        }
      },
    });
  };



  const handleTransferCancel = () => {
    setIsTransferModalVisible(false);
    transferForm.resetFields();
  };

  var index = 1;
  var aindex = 1;
  var tttasksTypes = Array(tasksTypes.length).fill(0);
  var months = [
    "يناير",
    "فبراير",
    "مارس",
    "إبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ];
  var tprevBalance = 0;
  var tcurrBalance = 0;
  var ttransBalance = 0;
  var topBalance = 0;
  var ttotalgBalance = 0;
  var tmonthsBalance = {
    m1: 0,
    m2: 0,
    m3: 0,
    m4: 0,
    m5: 0,
    m6: 0,
    m7: 0,
    m8: 0,
    m9: 0,
    m10: 0,
    m11: 0,
    m12: 0,
  };

  // Custom filter dropdown component for names
  const NamesFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const [searchText, setSearchText] = useState("");
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = () => {
      if (selectAll) {
        // Deselect all
        setSelectedKeys([]);
        setSelectAll(false);
      } else {
        // Select all
        const allValues = namesFilter
          .filter((name) => name.value !== "SELECT_ALL_NAMES")
          .map((name) => name.value);
        setSelectedKeys(allValues);
        setSelectAll(true);
      }
    };

    const handleConfirm = () => {
      confirm();
    };

    const handleClear = () => {
      clearFilters();
      setSelectedKeys([]);
      setSelectAll(false);
    };

    const filteredNames = namesFilter.filter(
      (name) =>
        name.value !== "SELECT_ALL_NAMES" &&
        name.text.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="البحث..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div style={{ marginBottom: 8 }}>
          <Checkbox
            checked={selectAll}
            onChange={handleSelectAll}
            style={{ fontWeight: "bold" }}
          >
            تحديد الكل
          </Checkbox>
        </div>
        <div style={{ maxHeight: 200, overflow: "auto" }}>
          {filteredNames.map((name) => (
            <div key={name.value} style={{ marginBottom: 4 }}>
              <Checkbox
                checked={selectedKeys.includes(name.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, name.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== name.value)
                    );
                  }
                  setSelectAll(false);
                }}
              >
                {name.text}
              </Checkbox>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 8, textAlign: "right" }}>
          <Button size="small" onClick={handleClear} style={{ marginRight: 8 }}>
            مسح
          </Button>
          <Button type="primary" size="small" onClick={handleConfirm}>
            تأكيد
          </Button>
        </div>
      </div>
    );
  };

  // Custom filter dropdown component for categories
  const CategoriesFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const [searchText, setSearchText] = useState("");
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = () => {
      if (selectAll) {
        // Deselect all
        setSelectedKeys([]);
        setSelectAll(false);
      } else {
        // Select all
        const allValues = categoriesFilter
          .filter((category) => category.value !== "SELECT_ALL_CATEGORIES")
          .map((category) => category.value);
        setSelectedKeys(allValues);
        setSelectAll(true);
      }
    };

    const handleConfirm = () => {
      confirm();
    };

    const handleClear = () => {
      clearFilters();
      setSelectedKeys([]);
      setSelectAll(false);
    };

    const filteredCategories = categoriesFilter.filter(
      (category) =>
        category.value !== "SELECT_ALL_CATEGORIES" &&
        category.text.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="البحث..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div style={{ marginBottom: 8 }}>
          <Checkbox
            checked={selectAll}
            onChange={handleSelectAll}
            style={{ fontWeight: "bold" }}
          >
            تحديد الكل
          </Checkbox>
        </div>
        <div style={{ maxHeight: 200, overflow: "auto" }}>
          {filteredCategories.map((category) => (
            <div key={category.value} style={{ marginBottom: 4 }}>
              <Checkbox
                checked={selectedKeys.includes(category.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, category.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== category.value)
                    );
                  }
                  setSelectAll(false);
                }}
              >
                {category.text}
              </Checkbox>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 8, textAlign: "right" }}>
          <Button size="small" onClick={handleClear} style={{ marginRight: 8 }}>
            مسح
          </Button>
          <Button type="primary" size="small" onClick={handleConfirm}>
            تأكيد
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Card>
      <Modal
        centered
        confirmLoading={saving}
        title={
          isEditMode
            ? `تعديل رصيد إجازة موظف - ${editingUserName || "موظف"
            } (سنة ${currentYear})`
            : "إضافة رصيد إجازة موظف"
        }
        open={isModalVisible}
        width={900}
        onCancel={handleCancel}
        onOk={onFinish}
      >
        <div className="tasks-modal-body">
          {/* النموذج العلوي - الإعدادات الأساسية */}
          {!isEditMode && (
            <div className="tasks-modal-section tasks-modal-section-primary">
              <h3 className="tasks-modal-section-title">الإعدادات الأساسية</h3>
              <Form form={gform} layout="vertical">
                <div className="tasks-modal-grid">
                  <Form.Item
                    name="task_id"
                    label="نوع الإجازة"
                    rules={[{ required: true, message: "مطلوب" }]}
                    style={{ marginBottom: "10px" }}
                  >
                    <Select
                      style={{ width: "100%" }}
                      showSearch
                      placeholder="اختر نوع الإجازة"
                      optionFilterProp="children"
                      notFoundContent={<Spin size="small" />}
                      filterOption={(input, option) =>
                        option.props.children?.indexOf(input) >= 0 ||
                        option.props.value?.indexOf(input) >= 0 ||
                        option.props.label?.indexOf(input) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.props?.children?.localeCompare(
                          optionB.props.children
                        )
                      }
                      onChange={(value) => {
                        const selectedTask = tasksTypes.find(
                          (t) => t.value === value
                        );
                        if (selectedTask && isAnnualTaskLabel(selectedTask.label)) {
                          gform.setFieldValue("period_type", "yearly");
                        }
                      }}
                    >
                      {tasksTypes.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="type"
                    label="نوع الرصيد"
                    style={{ marginBottom: "10px" }}
                  >
                    <Select
                      style={{ width: "100%" }}
                      showSearch
                      placeholder="اختر نوع الرصيد"
                      optionFilterProp="children"
                      options={
                        types && types.length > 0
                          ? types.filter(function (e) {
                            return e.parent == 34;
                          })
                          : []
                      }
                      notFoundContent={<Spin size="small" />}
                      filterOption={(input, option) =>
                        option.props.children?.indexOf(input) >= 0 ||
                        option.props.value?.indexOf(input) >= 0 ||
                        option.props.label?.indexOf(input) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.props?.children?.localeCompare(
                          optionB.props.children
                        )
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    name="period_type"
                    label="نوع الفترة"
                    rules={[{ required: true, message: "مطلوب" }]}
                    style={{ marginBottom: "10px" }}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="اختر الفترة"
                      disabled={
                        gform.getFieldValue("task_id") &&
                        (() => {
                          const selectedTask = tasksTypes.find(
                            (t) => t.value === gform.getFieldValue("task_id")
                          );
                          return selectedTask && isAnnualTaskLabel(selectedTask.label);
                        })()
                      }
                    >
                      <Option value="yearly">سنوية</Option>
                      <Option value="monthly">شهرية</Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="balance_year"
                    label="سنة الرصيد"
                    rules={[{ required: true, message: "مطلوب" }]}
                    style={{ marginBottom: "10px" }}
                    initialValue={dayjs(currentYear, "YYYY")}
                    extra="سيتم حفظ هذا الرصيد ضمن هذه السنة بغض النظر عن سنة الشاشة الحالية."
                  >
                    <DatePicker
                      picker="year"
                      placeholder="اختر السنة"
                      style={{ width: "100%" }}
                      format="YYYY"
                      needConfirm={false}
                      inputReadOnly={window.innerWidth <= 760}
                    />
                  </Form.Item>

                  <Form.Item
                    name="amount"
                    label="الرصيد (دقائق)"
                    style={{ marginBottom: "10px" }}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="0"
                      min={0}
                    />
                  </Form.Item>
                </div>

                <Form.Item
                  name="note"
                  label="ملاحظات"
                  style={{ marginBottom: "15px" }}
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder="ملاحظات (اختياري)"
                  />
                </Form.Item>

                {!isEditMode && (
                  <Form.Item
                    style={{ textAlign: "center", marginBottom: "10px" }}
                  >
                    <Button
                      type="primary"
                      loading={loadUsers}
                      onClick={showUsersDebt}
                      icon={<FormOutlined />}
                      size="large"
                      style={{ minWidth: "200px" }}
                    >
                      جلب الموظفين
                    </Button>
                  </Form.Item>
                )}
              </Form>
            </div>
          )}

          {/* النموذج الديناميكي - تفاصيل الموظفين */}
          <div className="tasks-modal-section">
            <h3 className="tasks-modal-section-title tasks-modal-section-title-green">
              {isEditMode ? "تفاصيل أنواع الإجازات" : "تفاصيل الموظفين"}
            </h3>
            <Form form={form}>
              <Form.List name="tasks">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <div key={key} className="tasks-employee-card">
                        {/* رأس الصف */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                            paddingBottom: "8px",
                            borderBottom: "1px solid #d9d9d9",
                          }}
                        >
                          <span
                            style={{ fontWeight: "bold", color: "#1890ff" }}
                          >
                            {isEditMode
                              ? `نوع إجازة #${name + 1}`
                              : `الموظف #${name + 1}`}
                          </span>
                          {!isEditMode && (
                            <Button
                              type="primary"
                              danger
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                            >
                              حذف
                            </Button>
                          )}
                        </div>

                        {/* الحقول الأساسية */}
                        <div className="tasks-employee-grid">
                          <Form.Item
                            {...restField}
                            name={[name, "id"]}
                            hidden={true}
                            style={{ display: "none" }}
                          >
                            <Input />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "ids_string"]}
                            hidden={true}
                            style={{ display: "none" }}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "user_id"]}
                            label="اسم الموظف"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{
                              marginBottom: "8px",
                              gridColumn: "1 / -1",
                            }}
                          >
                            <Select
                              showSearch
                              placeholder="اختر الموظف"
                              optionFilterProp="children"
                              disabled={isEditMode}
                              notFoundContent={<Spin size="small" />}
                              filterOption={(input, option) =>
                                option.props.children?.indexOf(input) >= 0 ||
                                option.props.value?.indexOf(input) >= 0 ||
                                option.props.label?.indexOf(input) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.props?.children?.localeCompare(
                                  optionB.props.children
                                )
                              }
                            >
                              {tstypes.map((item) => (
                                <Option key={item.value} value={item.value}>
                                  {item.label}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "task_id"]}
                            label="نوع الإجازة"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{ marginBottom: "8px" }}
                          >
                            <Select
                              showSearch
                              placeholder="اختر نوع الإجازة"
                              optionFilterProp="children"
                              disabled={isEditMode}
                              notFoundContent={<Spin size="small" />}
                              filterOption={(input, option) =>
                                option.props.children?.indexOf(input) >= 0 ||
                                option.props.value?.indexOf(input) >= 0 ||
                                option.props.label?.indexOf(input) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.props?.children?.localeCompare(
                                  optionB.props.children
                                )
                              }
                              onChange={(value) => {
                                const selectedTask = tasksTypes.find(
                                  (t) => t.value === value
                                );
                                if (
                                  selectedTask &&
                                  isAnnualTaskLabel(selectedTask.label)
                                ) {
                                  form.setFieldValue(
                                    [name, "period_type"],
                                    "yearly"
                                  );
                                }
                              }}
                            >
                              {tasksTypes.map((item) => (
                                <Option key={item.value} value={item.value}>
                                  {item.label}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "type"]}
                            label="نوع الرصيد"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{ marginBottom: "8px" }}
                          >
                            <Select
                              showSearch
                              placeholder="اختر نوع الرصيد"
                              optionFilterProp="children"
                              options={
                                types && types.length > 0
                                  ? types.filter(function (e) {
                                    return e.parent == 34;
                                  })
                                  : []
                              }
                              notFoundContent={<Spin size="small" />}
                              filterOption={(input, option) =>
                                option.props.children?.indexOf(input) >= 0 ||
                                option.props.value?.indexOf(input) >= 0 ||
                                option.props.label?.indexOf(input) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.props?.children?.localeCompare(
                                  optionB.props.children
                                )
                              }
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "amount"]}
                            label="الرصيد (دقائق)"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{ marginBottom: "8px" }}
                          >
                            <InputNumber
                              style={{ width: "100%" }}
                              placeholder="0"
                              min={0}
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "period_type"]}
                            label="نوع الفترة"
                            rules={[{ required: true, message: "مطلوب" }]}
                            style={{ marginBottom: "8px" }}
                          >
                            <Select
                              placeholder="اختر نوع الفترة"
                              disabled={
                                form.getFieldValue([name, "task_id"]) &&
                                (() => {
                                  const selectedTask = tasksTypes.find(
                                    (t) =>
                                      t.value ===
                                      form.getFieldValue([name, "task_id"])
                                  );
                                  return selectedTask && isAnnualTaskLabel(selectedTask.label);
                                })()
                              }
                            >
                              <Option value="yearly">سنوية</Option>
                              <Option value="monthly">شهرية</Option>
                            </Select>
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "note"]}
                            label="ملاحظات"
                            style={{
                              marginBottom: "8px",
                              gridColumn: "1 / -1",
                            }}
                          >
                            <TextArea
                              placeholder="ملاحظات (اختياري)"
                              rows={2}
                              style={{ resize: "vertical" }}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    ))}

                    {/* زر إضافة موظف جديد - يظهر فقط عند الإضافة */}
                    {!isEditMode && (
                      <Form.Item
                        style={{ textAlign: "center", marginTop: "15px" }}
                      >
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          icon={<PlusOutlined />}
                          style={{ minWidth: "200px" }}
                        >
                          إضافة موظف جديد
                        </Button>
                      </Form.Item>
                    )}
                  </>
                )}
              </Form.List>
            </Form>
          </div>
        </div>
      </Modal>

      <Modal
        centered
        confirmLoading={dsaving}
        title="خصم رصيد إجازة"
        open={isDModalVisible}
        onCancel={handleDCancel}
        onOk={onDFinish}
      >
        <Form form={dform} layout="vertical">
          <Form.Item
            name={"user_id"}
            label="اسم الموظف"
            rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
          >
            <Select
              style={{ width: "100%" }}
              showSearch
              placeholder="اختر الموظف"
              optionFilterProp="children"
              notFoundContent={<Spin style={{ textAlign: "center" }}></Spin>}
              filterOption={(input, option) =>
                option.props.children?.indexOf(input) >= 0 ||
                option.props.value?.indexOf(input) >= 0 ||
                option.props.label?.indexOf(input) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.props?.children?.localeCompare(optionB.props.children)
              }
            >
              <Option key="__ALL_USERS__" value="__ALL_USERS__">
                جميع الموظفين
              </Option>
              {tstypes.map((item) => (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <div style={{ display: 'flex', gap: '10px' }}>
            <Form.Item
              name={"year"}
              label={"السنة"}
              style={{ flex: 1 }}
              initialValue={dayjs(currentYear, "YYYY")}
              rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
            >
              <DatePicker
                picker="year"
                placeholder="السنة"
                style={{ width: "100%" }}
                format="YYYY"
              />
            </Form.Item>

            <Form.Item
              name={"task_id"}
              label="نوع الإجازة"
              style={{ flex: 1 }}
              rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
            >
              <Select
                showSearch
                placeholder="النوع"
                optionFilterProp="children"
                notFoundContent={<Spin style={{ textAlign: "center" }}></Spin>}
                filterOption={(input, option) =>
                  option.props.children?.indexOf(input) >= 0 ||
                  option.props.value?.indexOf(input) >= 0 ||
                  option.props.label?.indexOf(input) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.props?.children?.localeCompare(optionB.props.children)
                }
              >
                {tasksTypes.map((item) => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div style={{ display: 'flex', gap: '10px' }}>
            <Form.Item
              name={"amount"}
              label={"مقدار الخصم (دقيقة)"}
              style={{ flex: 1 }}
              rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
            >
              <InputNumber placeholder="الرصيد بالدقائق" style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              name={"discount_date"}
              label={"تاريخ الخصم"}
              style={{ flex: 1 }}
              rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
            >
              <DatePicker
                needConfirm={false}
                placeholder="التاريخ"
                style={{ width: "100%" }}
                inputReadOnly={window.innerWidth <= 760}
              />
            </Form.Item>
          </div>

          <Form.Item
            name={"note"}
            label={"ملاحظات"}
            rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
          >
            <TextArea placeholder="ملاحظات" rows={3} />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        centered
        confirmLoading={transferring}
        title="ترحيل الإجازات إلى السنة الجديدة"
        open={isTransferModalVisible}
        onCancel={handleTransferCancel}
        onOk={handleTransferLeaves}
        width={800}
        okText="ترحيل"
        cancelText="إلغاء"
      >
        <Form form={transferForm} layout="vertical">
          <Form.Item
            name="from_year"
            label="السنة المصدر"
            rules={[{ required: true, message: "هذا الحقل مطلوب" }]}
          >
            <DatePicker
              picker="year"
              style={{ width: "100%" }}
              placeholder="اختر السنة المصدر"
              needConfirm={false}
              inputReadOnly={window.innerWidth <= 760}
            />
          </Form.Item>

          <Form.Item
            name="to_year"
            label="السنة الهدف"
            rules={[
              { required: true, message: "هذا الحقل مطلوب" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const fromYear = getFieldValue("from_year");
                  if (!value || !fromYear) {
                    return Promise.resolve();
                  }
                  if (value.year() <= fromYear.year()) {
                    return Promise.reject(
                      new Error("السنة الهدف يجب أن تكون أكبر من السنة المصدر")
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <DatePicker
              picker="year"
              style={{ width: "100%" }}
              placeholder="اختر السنة الهدف"
              needConfirm={false}
              inputReadOnly={window.innerWidth <= 760}
            />
          </Form.Item>

          <Form.Item
            name="vacation_types"
            label="أنواع الإجازات (اختياري)"
            help="اتركه فارغاً لترحيل جميع أنواع الإجازات"
          >
            <Select
              mode="multiple"
              placeholder="اختر أنواع الإجازات (اتركه فارغاً للكل)"
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  ?.toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {tasksTypes.map((type) => (
                <Option key={type.value} value={type.value}>
                  {type.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="users"
            label="الموظفين (اختياري)"
            help="اتركه فارغاً لترحيل جميع الموظفين"
          >
            <Select
              mode="multiple"
              placeholder="اختر الموظفين (اتركه فارغاً للكل)"
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  ?.toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {empNames.map((emp) => (
                <Option key={emp.value} value={emp.value}>
                  {emp.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <div
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              padding: "10px",
              backgroundColor: "#e6f7ff",
              borderRadius: "6px",
              border: "1px solid #91d5ff",
            }}
          >
            <h4 style={{ margin: "0 0 10px 0", color: "#1890ff" }}>
              الرصيد الافتتاحي لكل نوع إجازة (بالدقائق)
            </h4>
            <p
              style={{ margin: "0 0 15px 0", color: "#666", fontSize: "12px" }}
            >
              يمكنك تحديد رصيد افتتاحي لكل نوع إجازة بالدقائق. سيتم إضافة الرصيد
              المرحل إلى الرصيد الافتتاحي المحدد.
            </p>
            <div>
              {tasksTypes.map((vacationType, index) => (
                <Form.Item
                  key={vacationType.value}
                  label={vacationType.label}
                  name={["opening_balances", vacationType.value]}
                  style={{ marginBottom: "10px" }}
                  initialValue={0}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="0"
                    min={0}
                    step={1}
                    precision={0}
                  />
                </Form.Item>
              ))}
            </div>
          </div>

          <div
            style={{
              padding: "15px",
              backgroundColor: "#f0f2f5",
              borderRadius: "6px",
              marginTop: "10px",
            }}
          >
            <p style={{ margin: 0, color: "#666", fontSize: "13px" }}>
              <strong>ملاحظة:</strong> سيتم ترحيل الرصيد المتبقي فقط (غير
              المستهلك) من السنة المصدر إلى السنة الهدف. الإجازات السنوية فقط
              سيتم ترحيلها. الرصيد المرحل سيتم إضافته إلى الرصيد الافتتاحي
              المحدد لكل نوع إجازة.
            </p>
          </div>
        </Form>
      </Modal>

      <div style={{ marginBottom: "10px" }}>
        <div className="discountHeader" style={{ marginBottom: "10px" }}>
          <div className="discountBtn">
            <DatePicker
              needConfirm={false}
              inputReadOnly={window.innerWidth <= 760}
              value={dayjs(currentYear, "YYYY")}
              onChange={onChange}
              placeholder="اختر سنة"
              picker="year"
            />
            <Button
              style={{
                marginLeft: "5px",
                marginRight: "5px",
                border: "none",
                backgroundColor: "#FAA61A",
                color: "#fff",
              }}
              onClick={function () {
                setIsDModalVisible(true);
              }}
            >
              <FormOutlined /> خصم رصيد{" "}
            </Button>

            <Button
              style={{
                marginLeft: "5px",
                marginRight: "5px",
                border: "none",
                backgroundColor: "#FAA61A",
                color: "#fff",
              }}
              onClick={function () {
                setIsEditMode(false);
                setEditingUserId(null);
                setEditingUserName(null);
                setIsModalVisible(true);
                form.resetFields();
                gform.resetFields();
                gform.setFieldsValue({
                  period_type: "yearly",
                  balance_year: dayjs(currentYear, "YYYY"),
                });
              }}
            >
              <FormOutlined /> إضافة رصيد
            </Button>
            <Button
              style={{ display: "block", margin: "0 10px" }}
              onClick={function () {
                exportToExcel("xlsx");
              }}
              type="primary"
            >
              <ExportOutlined />
            </Button>

            <Button
              style={{
                display: "block",
                backgroundColor: "#0972B6",
                borderColor: "#0972B6",
              }}
              onClick={function () {
                printReport();
              }}
              type="primary"
            >
              <PrinterOutlined />
            </Button>

            <Button
              style={{
                marginLeft: "5px",
                marginRight: "5px",
                border: "none",
                backgroundColor: "#52c41a",
                color: "#fff",
              }}
              onClick={function () {
                setIsTransferModalVisible(true);
              }}
              type="primary"
            >
              <SwapOutlined /> ترحيل الإجازات
            </Button>

            <Button
              style={{
                marginLeft: "5px",
                marginRight: "5px",
                border: "none",
                backgroundColor: "#ff4d4f",
                color: "#fff",
              }}
              onClick={handleResetYear}
              loading={resetting}
              danger
            >
              <ReloadOutlined /> تصفير سنة {currentYear}
            </Button>
          </div>
        </div>
      </div>
      <div className="report-screen-table-wrap">
        <Table
          loading={load}
          columns={getColumnsVac()}
          scroll={{ x: "1000px" }}
          dataSource={pdata}
          onChange={handleChange}
        />
      </div>
      <div id="att-report" style={{ display: "none" }}>
        <div
          style={{
            direction: "rtl",
            fontSize: "12px",
            fontFamily:
              "Tajawal, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            margin: "0",
          }}
        >
          <table
            style={{ fontSize: "11px", width: " 100%", textAlign: " center" }}
          >
            <thead>
              <tr style={{ border: "none" }}>
                <th colSpan={13}>
                  <header
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      borderColor: "#000",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1px",
                    }}
                  >
                    <div style={{ width: "20%" }}>
                      <img
                        loading="eager"
                        style={{ width: "250px" }}
                        src={
                          Env.HOST_SERVER_STORAGE +
                          props.setting.filter(
                            (item) => item.key == "admin.logo"
                          )[0]?.value
                        }
                      />
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "60%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end",
                        paddingBottom: "10px",
                      }}
                    >
                      <h1
                        style={{
                          fontSize: " 18px",
                          fontWeight: 700,
                          marginBottom: " 5px",
                          margin: "0",
                        }}
                      >
                        كشف أرصدة الإجازات{" "}
                      </h1>
                      <h2
                        style={{
                          fontSize: " 14px",
                          fontWeight: " 200",
                          margin: "0",
                        }}
                      >
                        للفترة من {start} إلى {end}
                      </h2>
                    </div>
                    <div style={{ width: "20%" }}></div>
                  </header>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      textAlign: "center",
                      fontSize: "14px",
                      borderBottom: "1px solid black",
                    }}
                  ></div>
                </th>
              </tr>
              <tr
                style={{
                  color: "#fff",
                  backgroundColor: "#0972B6",
                  height: "25px",
                }}
              >
                <th style={{ fontWeight: "100" }} rowSpan="2">
                  م
                </th>
                <th style={{ fontWeight: "100" }} rowSpan="2">
                  اسم الموظف
                </th>
                <th style={{ fontWeight: "100" }} rowSpan="2">
                  الوظيفة
                </th>

                {tasksTypes.map((item) => (
                  <th key={item.value} style={{ fontWeight: "100" }}>
                    {item.label}
                  </th>
                ))}
                <th style={{ fontWeight: "100" }} rowSpan="2">
                  ملاحظات
                </th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => {
                var catData = pdata?.filter(
                  (record) => record.category == category.name
                );

                var ttasksTypes = Array(tasksTypes.length).fill(0);

                if (catData.length)
                  return (
                    <React.Fragment key={category.id || category.name}>
                      {catData.map((item) => {
                        return (
                          <tr
                            key={item.user_id || item.empName}
                            style={{
                              height: " 25px",
                              backgroundColor:
                                index % 2 == 0 ? "#e6e6e6" : "#fff",
                            }}
                          >
                            <td>{index++}</td>
                            <td>{item.empName}</td>
                            <td>{item.job}</td>
                            {tasksTypes.map((task, index) => {
                              var taskAmount = item[task.label];

                              // تحسين عرض المدة
                              if (
                                !taskAmount ||
                                taskAmount === "0" ||
                                taskAmount === 0
                              ) {
                                taskAmount = "00:00";
                              } else if (typeof taskAmount === "string") {
                                // إذا كانت بصيغة "ساعة:دقيقة" أو "ساعة:دقيقة:ثانية"
                                taskAmount = taskAmount.replace(
                                  /(\d{1,2}:\d{2}):\d{2}/,
                                  "$1"
                                );
                                // التأكد من أن الأرقام مكونة من رقمين
                                const parts = taskAmount.split(":");
                                if (parts.length === 2) {
                                  const hours = parseInt(parts[0]) || 0;
                                  const mins = parseInt(parts[1]) || 0;
                                  // عرض الساعات بدون padding إذا كانت أكثر من 99 ساعة
                                  const hoursStr =
                                    hours >= 100
                                      ? String(hours)
                                      : String(hours).padStart(2, "0");
                                  taskAmount =
                                    hoursStr +
                                    ":" +
                                    String(mins).padStart(2, "0");
                                }
                              } else if (typeof taskAmount === "number") {
                                // إذا كانت بالدقائق (رقم)
                                const hours = Math.floor(
                                  Math.abs(taskAmount) / 60
                                );
                                const mins = Math.abs(taskAmount) % 60;
                                const sign = taskAmount < 0 ? "-" : "";
                                // عرض الساعات بدون padding إذا كانت أكثر من 99 ساعة
                                const hoursStr =
                                  hours >= 100
                                    ? String(hours)
                                    : String(hours).padStart(2, "0");
                                taskAmount =
                                  sign +
                                  hoursStr +
                                  ":" +
                                  String(mins).padStart(2, "0");
                              }

                              var taskSplit = taskAmount.split(":");
                              var finalTask = 0;
                              if (
                                taskAmount &&
                                taskAmount !== "00:00" &&
                                taskAmount !== "0"
                              ) {
                                const hours = parseInt(taskSplit[0]) || 0;
                                const mins = parseInt(taskSplit[1]) || 0;
                                finalTask = Math.abs(hours * 60) + mins;
                                if (taskAmount.startsWith("-")) {
                                  finalTask = -finalTask;
                                }
                              }

                              ttasksTypes[index] =
                                ttasksTypes[index] + parseInt(finalTask);
                              tttasksTypes[index] =
                                tttasksTypes[index] + parseInt(finalTask);

                              return (
                                <td
                                  key={task.value}
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "monospace",
                                    fontWeight:
                                      taskAmount !== "00:00" ? "500" : "normal",
                                    color: taskAmount.startsWith("-")
                                      ? "#ff4d4f"
                                      : taskAmount !== "00:00"
                                        ? "#1890ff"
                                        : "#999",
                                  }}
                                >
                                  {taskAmount}
                                </td>
                              );
                            })}
                            <td>
                              <pre> </pre>
                            </td>
                          </tr>
                        );
                      })}
                      <tr
                        style={{
                          height: " 30px",
                          color: "#fff",
                          backgroundColor: "#0972B6",
                        }}
                      >
                        <td colSpan={3}>{category.name}</td>
                        {tasksTypes.map((task, index) => {
                          return (
                            <td key={task.value}>
                              {parseInt(ttasksTypes[index] / 60) +
                                ":" +
                                (ttasksTypes[index] % 60)}
                            </td>
                          );
                        })}
                        <td>
                          <pre> </pre>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                return null;
              })}
              <tr
                style={{
                  height: " 30px",
                  color: "#fff",
                  backgroundColor: "#0972B6",
                }}
              >
                <td colSpan={3}>{"الإجمالي العام"}</td>
                {tasksTypes.map((task, index) => {
                  return (
                    <td key={task.value}>
                      {parseInt(tttasksTypes[index] / 60) +
                        ":" +
                        (tttasksTypes[index] % 60)}
                    </td>
                  );
                })}
                <td>
                  <pre> </pre>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={16}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "20px",
                      textAlign: "center",
                    }}
                  >
                    {props.setting
                      .filter((item) => item.key == "admin.signs_footer")[0]
                      ?.value.split("\n")
                      .map((sign) => {
                        var sign_position = sign.split(":")[0];
                        var sign_name = sign.split(":")[1];

                        return (
                          <div style={{ width: "50%" }}>
                            <div style={{ fontWeight: "900" }}>
                              {sign_position}
                            </div>
                            {sign_name != "" && (
                              <div style={{ fontWeight: "500" }}>
                                {sign_name}
                              </div>
                            )}
                          </div>
                        );
                      })}{" "}
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>
          <div
            style={{
              marginTop: " 20px",
              width: "85%",
              backgroundColor: "#e6e6e61",
              padding: "5px 0",
              borderTopLeftRadius: " 5px",
              borderBottomLeftRadius: " 5px",
            }}
          >
            <div
              style={{
                backgroundColor: " #0972B6",
                width: " 95%",
                height: " 15px",
                borderTopLeftRadius: " 5px",
                borderBottomLeftRadius: " 5px",
                color: " #fff",
                paddingRight: " 20px",
              }}
            >
              نظام دوام | {new Date().toLocaleString("en-IT")}{" "}
            </div>
          </div>
        </div>
      </div>
      <div id="ann-report" style={{ display: "none" }}>
        <div
          style={{
            direction: "rtl",
            fontSize: "12px",
            fontFamily:
              "Tajawal, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            margin: "0",
          }}
        >
          <table
            className="equal-table"
            style={{ fontSize: "11px", width: " 100%", textAlign: " center" }}
          >
            <thead>
              <tr style={{ border: "none" }}>
                <th colSpan={21}>
                  <header
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      borderColor: "#000",
                      borderBottomStyle: "solid",
                      borderBottomWidth: "1px",
                    }}
                  >
                    <div style={{ width: "20%" }}>
                      <img
                        loading="eager"
                        style={{ width: "250px" }}
                        src={
                          Env.HOST_SERVER_STORAGE +
                          props.setting.filter(
                            (item) => item.key == "admin.logo"
                          )[0]?.value
                        }
                      />
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "60%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "end",
                        paddingBottom: "10px",
                      }}
                    >
                      <h1
                        style={{
                          fontSize: " 18px",
                          fontWeight: 700,
                          marginBottom: " 5px",
                          margin: "0",
                        }}
                      >
                        كشف السنوية لعام {currentYear}م
                      </h1>
                    </div>
                    <div style={{ width: "20%" }}></div>
                  </header>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      textAlign: "center",
                      fontSize: "14px",
                      borderBottom: "1px solid black",
                    }}
                  ></div>
                </th>
              </tr>

              <tr style={{ color: "#fff", backgroundColor: "#0972B6" }}>
                <th style={{ fontWeight: "100" }}>م</th>
                <th style={{ fontWeight: "100" }}>اسم الموظف</th>
                <th style={{ fontWeight: "100" }}>الوظيفة</th>
                <th style={{ fontWeight: "100", width: "50px" }}>
                  مرحل من العام الماضي
                </th>
                <th style={{ fontWeight: "100", width: "50px" }}>
                  رصيد العام الحالي
                </th>
                <th style={{ fontWeight: "100", width: "50px" }}>رصيد محول</th>
                <th style={{ fontWeight: "100" }}>الافتتاحي</th>

                {months.map((m, ind) => {
                  return (
                    <th
                      key={ind}
                      className="equal"
                      style={{
                        fontWeight: "100",
                        whiteSpace: "nowrap",
                        transform: "rotate(-180deg)",
                        writingMode: "vertical-rl",
                        height: "30px",
                        width: "30px",
                        maxWidth: "30px",
                      }}
                    >
                      {months[ind]}
                    </th>
                  );
                })}
                <th style={{ fontWeight: "100" }}> الممنوح</th>
                <th style={{ fontWeight: "100" }}> المتبقي</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => {
                var catData = pannTasks.filter(
                  (record) => record.category == category.name
                );
                var prevBalance = 0;
                var currBalance = 0;
                var transBalance = 0;
                var opBalance = 0;
                var totalgBalance = 0;
                var monthsBalance = {
                  m1: 0,
                  m2: 0,
                  m3: 0,
                  m4: 0,
                  m5: 0,
                  m6: 0,
                  m7: 0,
                  m8: 0,
                  m9: 0,
                  m10: 0,
                  m11: 0,
                  m12: 0,
                };
                if (catData.length)
                  return (
                    <React.Fragment key={category.id || category.name}>
                      {catData.map((item) => {
                        prevBalance += item.prev * 1;
                        currBalance += item.curr * 1;
                        transBalance += item.trans * 1;
                        var totalg = 0;
                        var op =
                          Math.round(item.prev) +
                          Math.round(item.curr) +
                          Math.round(item.trans);
                        opBalance += op;

                        tprevBalance += item.prev * 1;
                        tcurrBalance += item.curr * 1;
                        ttransBalance += item.trans * 1;
                        topBalance += op;

                        return (
                          <tr
                            key={item.user_id || item.name || aindex}
                            style={{
                              height: " 25px",
                              backgroundColor:
                                aindex % 2 == 0 ? "#e6e6e6" : "#fff",
                            }}
                          >
                            <td style={{ fontWeight: "100" }}>{aindex++}</td>
                            <td style={{ fontWeight: "100" }}>{item.name}</td>
                            <td style={{ fontWeight: "100", width: "100px" }}>
                              {item.job}
                            </td>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(item.prev / 60) +
                                ":" +
                                Math.round(item.prev % 60)}
                            </th>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(item.curr / 60) +
                                ":" +
                                Math.round(item.curr % 60)}
                            </th>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(item.trans / 60) +
                                ":" +
                                Math.round(item.trans % 60)}
                            </th>
                            <th style={{ fontWeight: "100" }}>
                              {parseInt(op / 60) + ":" + (op % 60)}
                            </th>
                            {months.map((m, ind) => {
                              var min = item["m" + (ind + 1)] / 60;
                              totalg += min;
                              totalgBalance += min;
                              monthsBalance["m" + (ind + 1)] += min;
                              ttotalgBalance += min;
                              tmonthsBalance["m" + (ind + 1)] += min;
                              return (
                                <td
                                  key={ind}
                                  className="equal"
                                  style={{ fontWeight: "100" }}
                                >
                                  {parseInt(min / 60) + ":" + (min % 60)}
                                </td>
                              );
                            })}
                            <td style={{ fontWeight: "100" }}>
                              {Math.round((totalg / 60 / 7) * 100) / 100}
                            </td>
                            <th style={{ fontWeight: "100" }}>
                              {Math.round(((op - totalg) / 60 / 7) * 100) / 100}
                            </th>
                          </tr>
                        );
                      })}
                      <tr
                        style={{
                          height: " 25px",
                          color: "#fff",
                          backgroundColor: "#0972B6",
                        }}
                      >
                        <td style={{ fontWeight: "100" }} colSpan={3}>
                          {category.name}
                        </td>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(prevBalance / 60) +
                            ":" +
                            Math.round(prevBalance % 60)}
                        </th>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(currBalance / 60) +
                            ":" +
                            Math.round(currBalance % 60)}
                        </th>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(transBalance / 60) +
                            ":" +
                            Math.round(transBalance % 60)}
                        </th>
                        <th style={{ fontWeight: "100" }}>
                          {parseInt(opBalance / 60) + ":" + (opBalance % 60)}
                        </th>
                        {months.map((m, ind) => {
                          var min = monthsBalance["m" + (ind + 1)];
                          return (
                            <td
                              key={ind}
                              className="equal"
                              style={{ fontWeight: "100" }}
                            >
                              {parseInt(min / 60) + ":" + (min % 60)}
                            </td>
                          );
                        })}
                        <td style={{ fontWeight: "100" }}>
                          {Math.round((totalgBalance / 60 / 7) * 100) / 100}
                        </td>
                        <th style={{ fontWeight: "100" }}>
                          {Math.round(
                            ((opBalance - totalgBalance) / 60 / 7) * 100
                          ) / 100}
                        </th>
                      </tr>
                    </React.Fragment>
                  );
                return null;
              })}
              <tr
                style={{
                  height: " 30px",
                  color: "#fff",
                  backgroundColor: "#0972B6",
                }}
              >
                <td colSpan={3}>{"الإجمالي العام"}</td>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(tprevBalance / 60) +
                    ":" +
                    Math.round(tprevBalance % 60)}
                </th>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(tcurrBalance / 60) +
                    ":" +
                    Math.round(tcurrBalance % 60)}
                </th>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(ttransBalance / 60) +
                    ":" +
                    Math.round(ttransBalance % 60)}
                </th>
                <th style={{ fontWeight: "100" }}>
                  {parseInt(topBalance / 60) + ":" + (topBalance % 60)}
                </th>
                {months.map((m, ind) => {
                  var min = tmonthsBalance["m" + (ind + 1)];
                  return (
                    <td
                      key={ind}
                      className="equal"
                      style={{ fontWeight: "100" }}
                    >
                      {parseInt(min / 60) + ":" + (min % 60)}
                    </td>
                  );
                })}
                <td style={{ fontWeight: "100" }}>
                  {Math.round((ttotalgBalance / 60 / 7) * 100) / 100}
                </td>
                <th style={{ fontWeight: "100" }}>
                  {Math.round(((topBalance - ttotalgBalance) / 60 / 7) * 100) /
                    100}
                </th>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={21}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "20px",
                      textAlign: "center",
                    }}
                  >
                    {props.setting
                      .filter((item) => item.key == "admin.signs_footer")[0]
                      ?.value.split("\n")
                      .map((sign) => {
                        var sign_position = sign.split(":")[0];
                        var sign_name = sign.split(":")[1];

                        return (
                          <div style={{ width: "50%" }}>
                            <div style={{ fontWeight: "900" }}>
                              {sign_position}
                            </div>
                            {sign_name != "" && (
                              <div style={{ fontWeight: "500" }}>
                                {sign_name}
                              </div>
                            )}
                          </div>
                        );
                      })}{" "}
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>
          <div
            style={{
              marginTop: " 20px",
              width: "85%",
              backgroundColor: "#e6e6e61",
              padding: "5px 0",
              borderTopLeftRadius: " 5px",
              borderBottomLeftRadius: " 5px",
            }}
          >
            <div
              style={{
                backgroundColor: " #0972B6",
                width: " 95%",
                height: " 15px",
                borderTopLeftRadius: " 5px",
                borderBottomLeftRadius: " 5px",
                color: " #fff",
                paddingRight: " 20px",
              }}
            >
              نظام دوام | {new Date().toLocaleString("en-IT")}{" "}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
